import { render } from "./ContactCta.vue?vue&type=template&id=2993cf66&scoped=true"
import script from "./ContactCta.vue?vue&type=script&lang=js"
export * from "./ContactCta.vue?vue&type=script&lang=js"

import "./ContactCta.vue?vue&type=style&index=0&id=2993cf66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2993cf66"]])

export default __exports__